<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre" id="pgepubid00005"><span class="calibre1" id="Page_81" title="81"></span><span>Afternoon Session</span></h2>
<p class="pindent">MR. COUNSELLOR RAGINSKY: The looting and destruction
of historical and artistic palaces in the town of Pushkin (Tzarskoe-Selo)
was carried out with malice aforesight by order of the
highest German authorities.</p>
<p class="pindent">I omit the end of Page 47 and the beginning of Page 48:</p>
<div class="blockquote">
<p class="calibre3">“A considerable part of the Catherine Palace was burned
down by the Germans. The famous ceremonial halls, 300
meters long and designed by Rastrelli, perished in the flames.
The famous antechambers”—waiting rooms—“decorated by
Rastrelli were likewise ruined.”</p>
</div>
<p class="pindent">I omit one paragraph and continue:</p>
<div class="blockquote">
<p class="calibre3">“The Great Hall—outstanding creation of the genius of
Rastrelli—presented a terrible spectacle. The unique ceilings,
work of Torelli, Giordano, Brullov, and other famous Italian
and Russian masters, were destroyed.”</p>
</div>
<p class="pindent">I omit another paragraph.</p>
<div class="blockquote">
<p class="calibre3">“Equally ruined and pillaged was the Palace Church, one of
Rastrelli’s masterpieces, famous for the exquisite workmanship
of the interior decoration.”</p>
</div>
<p class="pindent">I omit one more paragraph.</p>
<div class="blockquote">
<p class="calibre3">“In January 1944 the retreating German invaders prepared
the complete destruction of all that was left of the Catherine
Palace and adjoining buildings. For this purpose, on the
ground floor of the remaining part of the palace, as well as
under the Cameron Gallery, 11 large delayed-action aerial
bombs were laid, weighing from 1 to 3 tons.</p>
<p class="calibre3">“In Pushkin the Hitlerite bandits destroyed the Alexander
Palace, constructed at the end of the 18th century by the
famous architect Giacomo Quarenghi.”</p>
</div>
<p class="pindent">I omit a paragraph.</p>
<div class="blockquote">
<p class="calibre3">“All the museum furniture, stored in the basements of the
Catherine and Alexander Palaces, items of artistic porcelain,
and books from the palace libraries were sent to Germany.</p>
<p class="calibre3">“The famous painted ceiling, ‘Feast of the Gods on Olympus,’
in the main hall of the Hermitage pavilion was removed
and shipped to Germany.”</p>
</div>
<p class="pindent">I omit two paragraphs:</p>
<div class="blockquote">
<p class="calibre3">“Great destructions were caused by the Hitlerites in the
magnificent Pushkin parks, where thousands of age-old trees
were cut down.
<span id="Page_82" title="82"></span></p>
<p class="calibre3">“Ribbentrop’s special purpose battalion and the Kommandos
Staff Rosenberg shipped to Germany from the Pavlovsky
Palace extremely valuable palace furniture, designed by
Veronikhin and by the greatest masters of the 18th century.”</p>
</div>
<p class="pindent">I omit the end of Page 49 and the beginning of Page 50 of the
report.</p>
<div class="blockquote">
<p class="calibre3">“During their retreat the fascist invaders set fire to the
Paul’s Palace. The greater part of the palace building was
entirely burned down.”</p>
</div>
<p class="pindent">I omit the next two paragraphs and quote the last paragraph,
which concludes this document:</p>
<div class="blockquote">
<p class="calibre3">“The Extraordinary State Commission established that the
destruction of art monuments in Petrodvoretz, Pushkin, and
Pavlovsk was carried out by the officers and soldiers of the
German Army on the direct instructions of the German
Government and the High Command.”</p>
</div>
<p class="pindent">Many large towns were destroyed by the German fascist invaders
in the occupied U.S.S.R. territories. But they destroyed with particular
ruthlessness the ancient Russian cities containing monuments
of ancient Russian art. I quote as an example the destruction of the
cities of Novgorod, Pskov, and Smolensk. Novgorod and Pskov belong
to these historical centers where the Russian people laid the foundation
of their state; here, in the course of centuries flourished a
highly developed and individual culture. It left a rich heritage
which constitutes a valuable possession of our people. Thanks to
the survival of numerous monuments of ecclesiastic and civil
architecture, murals, paintings, sculpture, and handicraft, Novgorod
and Pskov were rightly considered the seat of Russian history.</p>
<p class="pindent">The Hitlerite barbarians destroyed, in Novgorod, many valuable
monuments of Russian and foreign art of the 11th and 12th
centuries. They not only destroyed the monuments but they
reduced the entire city to a heap of ruins.</p>
<p class="pindent">By way of proof, I shall read into the record some excerpts
from the document presented to the Tribunal as Document Number
USSR-50. You will, Your Honors, find these excerpts on Pages 333
and 334 of the document book. I read:</p>
<div class="blockquote">
<p class="calibre3">“The ancient Russian city of Novgorod was reduced to a heap
of ruins by the German fascist invaders. They destroyed
the historical monuments and dismantled some of them for
use in the construction of defense fortifications. . . .</p>
<p class="calibre3">“The German fascist vandals destroyed and obliterated, in
Novgorod, the greatest monuments of ancient Russian art.
The fascists destroyed the vaults and walls of the Saint
George Cathedral tower of the Yuryev Monastery. This
<span id="Page_83" title="83"></span>
cathedral was built in the early part of the 12th century,
was decorated by 12th century frescoes.</p>
<p class="calibre3">“The Cathedral of Saint Sophia, built in the 11th century,
was one of the oldest monuments of Russian architecture
and an outstanding monument of world art. The Germans
destroyed the cathedral building. . . .</p>
<p class="calibre3">“The Hitlerites robbed the cathedral entirely of all its interior
decorations; they carried off all the icons from the iconostasis
and the ancient chandeliers, including one which belonged to
Boris Godunov. . . .</p>
<p class="calibre3">“The Church of the Annunciation on the Arkage, dating back
to the 12th century, was converted by the fascists into a
fortified position and barracks.”</p>
</div>
<p class="pindent">I omit one paragraph.</p>
<div class="blockquote">
<p class="calibre3">“The Church of the Assumption on Volotov Field, a monument
of Novgorod architecture of the 14th-15th centuries,
was turned by the Germans into a heap of stones and bricks.”</p>
</div>
<p class="pindent">I omit one sentence.</p>
<div class="blockquote">
<p class="calibre3">“The Church of the Transfiguration of our Lord, in Ilyin
Street, was destroyed. It was one of the finest specimens
of Novgorod architecture of the 14th century, particularly
famed for its frescoes, painted in the same period by the
great Byzantine master, Theofan, the Greek.”</p>
</div>
<p class="pindent">I omit the rest of this page and pass on to Page 54, of my
report.</p>
<div class="blockquote">
<p class="calibre3">“Over 2 years of Hitlerite rule in Novgorod brought about the
ruin of many other wonderful, ancient monuments of Russian
architecture. . . . By order of the commanding general of the
18th German Army, Generaloberst Lindemann, the German
barbarians dismantled and prepared for removal to Germany
the monument to ‘a thousand years of Russia.’ This monument
was erected in the Kremlin Square in 1862 and represented,
in artistic images, the main stages of the development
of our native land up to the sixties of the 19th century. . . .</p>
<p class="calibre3">“The Hitler barbarians dismantled the monument and smashed
the statuary. They did not, however, succeed in shipping
it off and melting down the metal.”</p>
</div>
<p class="pindent">Citizen Youri Nikolaievich Dimitriev, in his affidavit, gives a
very detailed account of the barbarous destruction by the Germans
of the monuments of ancient Russian art in the cities of Novgorod
and Pskov. Dimitriev, since 1937, was the custodian of the Ancient
Russian Art Section of the Russian State Museum in Leningrad.
He began the study of the historical monuments of Novgorod and
Pskov in 1926. As a great expert in this particular sphere of art,
<span id="Page_84" title="84"></span>
he was asked by the Extraordinary State Commission of the Soviet
Union to participate in the investigation of the crimes of the
German fascist invaders.</p>
<p class="pindent">I submit to the Tribunal the original of Dimitriev’s depositions,
duly certified, in accordance with legal procedure in the U.S.S.R.,
as Document Number USSR-312 (Exhibit Number USSR-312). You
will find it, Your Honors, on Pages 335 and 347 in your document
book. In submitting his affidavit, I shall omit facts already known
to the Tribunal from the report of the Extraordinary State Commission
previously read into the record. I quote only a few short
excerpts which will be found on Pages 336 and 339. Mr. Dimitriev
stated as follows—I read:</p>
<div class="blockquote">
<p class="calibre3">“The greater part of Novgorod is razed to the ground; only
a few districts were left by the Germans and even these
were in ruins. Pskov was also left in ruins by the Germans;
during their retreat they blew up the buildings and monuments.
Of 88 buildings of historical and artistic value in
Novgorod only two buildings are without grave damages. . . .
Only a few isolated monuments in Pskov were left
undamaged.</p>
<p class="calibre3">“In Novgorod and Pskov the Germans deliberately destroyed
monuments of historical and artistic value.”</p>
</div>
<p class="pindent">And further:</p>
<div class="blockquote">
<p class="calibre3">“The German Army, while destroying and damaging monuments
of historical and artistic value, plundered and carried
off works of art and valuable objects which formed part of,
or were contained in, these monuments.</p>
<p class="calibre3">“At the same time the German troops profaned and
desecrated several ecclesiastical monuments of historic and
artistic value in Novgorod and Pskov.”</p>
</div>
<p class="pindent">Day by day for 26 months, the Hitlerites systematically
destroyed one of the most ancient Russian cities, Smolensk.</p>
<p class="pindent">The Soviet Prosecution has presented to the Tribunal a document
as Document Number USSR-56, containing the report of the Extraordinary
State Commission of the Soviet Union. I shall not quote
this document; but I shall only refer to it and endeavor, in my
own words, to emphasize the fundamental points of this document,
dealing with the reported theme now.</p>
<p class="pindent">In Smolensk, the German fascist invaders plundered and
destroyed the most valuable collections in the museums. They
desecrated and burned down ancient monuments; they destroyed
schools and institutes, libraries, and sanatoriums. The report also
mentions the fact that in April 1943, the Germans needed rubble
to pave the roads. For this purpose, they blew up the intermediate
<span id="Page_85" title="85"></span>
school. The Germans burned down all the libraries of the city
and 22 schools; 646,000 volumes perished in the library fires.</p>
<p class="pindent">I now pass on to Page 57 of my report:</p>
<div class="blockquote">
<p class="calibre3">“Prior to the German occupation Smolensk contained four
museums with extremely valuable collections.</p>
<p class="calibre3">“The museum of art possessed most valuable collections,
primarily of Russian historic-artistic, historic-sociological,
ethnographic, and other valuables: paintings, icons, bronzes,
porcelains, metal castings, and textiles. These collections
were of international value and had been exhibited in France.
The invaders destroyed the museums and took the most
valuable exhibits to Germany.”</p>
</div>
<p class="pindent">I shall quote only one last paragraph on Page 57:</p>
<div class="blockquote">
<p class="calibre3">“The Einsatzstab Rosenberg for the confiscation and exportation
of valuables from the occupied regions of the East had
a special branch in Smolensk, headed by Dr. Norling, the
organizer for the plunder of museums and historical
monuments.”</p>
</div>
<p class="pindent">Such are some of the numerous facts of the crimes committed
by the fascist barbarians. They demonstrate how the criminal
schemes of the Hitlerite conspirators were actually materialized.</p>
<p class="pindent">It is known how mercilessly the German fascist invaders carried
out the economic plunder of the Ukrainian people. But destruction
and plunder of Ukrainian cultural and historical treasures
played no lesser part in the plans of the Hitlerite conspirators, and
was carried out with the same savage zeal. In accordance with
their criminal plans for the enslavement of the freedom-loving
Ukrainian people, the Hitlerite conspirators endeavored to annihilate
its culture. From the very first days of their invasion of the
Ukraine the Hitlerites, in execution of their criminal designs,
embarked upon the systematic destruction of schools, higher educational
institutions, scientific establishments, museums, libraries,
clubs, and theaters.</p>
<p class="pindent">The historical and cultural treasures in the cities of Kiev, Kharkov,
Odessa, in the Provinces of Stalino and Rovno, and many
other larger and smaller cities, were subjected to plunder and
destruction.</p>
<p class="pindent">From the document presented by the Soviet Prosecution under
Document Number USSR-32, containing the sentence pronounced by
the military tribunal of the 4th Ukrainian Front between 15-18
December 1943, it is evident that the German fascist armies of
Kharkov, in the Province of Kharkov, acting on direct instructions
of Hitler’s Government, burned, plundered, and destroyed the
<span id="Page_86" title="86"></span>
material and cultural treasures of the Soviet people. These excerpts,
Your Honors, you will find on Page 359 in your document book.</p>
<p class="pindent">I now proceed to the evidence of crimes committed by the
Hitlerites in the capital of the Ukrainian Republic, Kiev. I quote
one paragraph of the document presented by the Soviet Prosecution
under Document Number USSR-248. You will find it on Page 363
of your document book. It is an extract from the records of the
Extraordinary State Commission “about the destruction and plunder
by the fascist aggressors of Kiev’s Psychiatric Hospital.” Among
other destructions they—I quote:</p>
<div class="blockquote">
<p class="calibre3">“. . . burned the archives of the institute, priceless from a
scientific point of view, destroyed the magnificent hospital
library of 20,000 volumes, plundered the especially protected
and priceless monument of the 11th century—the famous
Cathedral of Saint Cyryl situated in the institute grounds.”</p>
</div>
<p class="pindent">I next pass on to several excerpts from the Extraordinary State
Commission’s report which was presented to the Tribunal as Exhibit
Number USSR-9 (Document Number USSR-9). The excerpts quoted
are on Pages 365-366 of the document book:</p>
<div class="blockquote">
<p class="calibre3">“Before the German invasion, Kiev possessed 150 secondary
and elementary schools. Of this number, 77 schools were
used by the Germans as military barracks. Nine served as
warehouses and workshops, two were occupied by military
staffs and eight were turned into stables. During their
retreat from Kiev, the German barbarians destroyed 140
schools.”</p>
</div>
<p class="pindent">I omit the next paragraph.</p>
<div class="blockquote">
<p class="calibre3">“The German invaders stole more than 4 million volumes
from the book stocks of the Kiev libraries. From the library
of the Ukrainian S.S.R. Academy of Science alone the
Hitlerites sent to Germany over 320,000 various valuable and
unique books, magazines, and manuscripts.”</p>
</div>
<p class="pindent">I beg Your Honors to note that Dr. Förster, SS Obersturmführer,
who served in the special purpose battalion, established on the
initiative of the Defendant Ribbentrop and acting under his orders,
testified to the plunder of the library of the Ukrainian S.S.R.,
Academy of Science, in his deposition of 10 November 1942, which I
have already read into the record.</p>
<p class="pindent">I omit one paragraph and pass on to a further reading from
the report of the Extraordinary State Commission:</p>
<div class="blockquote">
<p class="calibre3">“On 5 September 1943 the Germans burned and blew up one
of the most ancient centers of Ukrainian culture, the T. G.
Shevtchenko State University in Kiev, founded in 1834. In
<span id="Page_87" title="87"></span>
the fire perished the greatest of cultural treasures which for
centuries had represented the scientific and educational bases
on which the work of the university was founded; perished,
the priceless documents from the historical archives of ancient
manuscripts; perished, the library containing over 1,300,000
books; destroyed, the zoological museum of the university
with over 2 million exhibits, together with a whole series of
other museums. . . .</p>
<p class="calibre3">“. . . The German occupiers also destroyed other institutions
of higher learning in Kiev; they burned and looted the
majority of the medical institutions.</p>
<p class="calibre3">“In Kiev the fascist barbarians burned down the building
of the Red Army Dramatic Theater . . . , the Theatrical
Institute, the Academy of Music, where the instruments were
burned together with the very wealthy library and all the
equipment; they blew up the beautiful circus building; they
burned down, with its entire equipment, the M. Gorki Theater
for Juvenile Audiences; they destroyed the Jewish theater. . . .</p>
<p class="calibre3">“In the Museum of Western European and Eastern Art only
some large canvases were left; the robbers had not had time
to remove them from the high walls of the stairway shafts.
From the Museum of Russian Art the Hitlerites carried off,
together with all the other exhibits, a collection of Russian
icons of inestimable value. They looted the Museum of
Ukrainian Art; only 1,900 exhibits of the National Art Section
of this museum were left of the original 41,000.”</p>
</div>
<p class="pindent">I omit the remainder of this page and pass to Page 62 of my
report:</p>
<div class="blockquote">
<p class="calibre3">“The Hitlerites plundered the T. G. Shevtchenko Museum and
the historical museum. They looted the greatest monument
to the Slav peoples—the Cathedral of Saint Sophia—from
which they removed 14 12th century frescoes.”</p>
<p class="calibre3">I omit one paragraph.</p>
<p class="calibre3">“By order of the German Command the troops plundered,
blew up, and destroyed a very ancient cultural monument—the
Kievo-Pecherskaya Abbey. . . .</p>
<p class="calibre3">“The Uspenski Cathedral, built in 1075-89 by the order of
Grand Duke Svjatoslav, with murals painted in 1897 by the
famous painter V. V. Vereshchiagin, was blown up by the
Germans on 3 November 1941.”</p>
</div>
<p class="pindent">I omit the remainder of Page 62 and pass on to Page 63 of the
report:
<span id="Page_88" title="88"></span></p>
<div class="blockquote">
<p class="calibre3">“We cannot gaze without sorrow”—states Nicholas, Metropolitan
of Kiev and Galicia, and member of the Extraordinary
State Commission—“on the heaps of rubble of the
Uspenski Cathedral, founded in the 11th century by the
genius of its immortal builders. The explosions formed
several huge craters in the area surrounding the cathedral,
and, beholding them, it would appear that the very earth
had shuddered at the sight of the atrocities committed by
those who no longer had a right to be called human beings.
It was as if a terrible hurricane had passed over the abbey,
overturning everything, scattering and destroying the mighty
buildings of the abbey. For over 2 years Kiev lay shackled
in the German chains. Hitler’s executioners brought death
to Kiev, together with ruins, famine, and executions. In
time all this will pass from the near present to the far distant
past; but never will the people of Russia and the Ukraine,
or honest men all the world over, forget these crimes.”</p>
</div>
<p class="pindent">Mr. President, may I dwell on two more documents?</p>
<p class="pindent">The first, Document Number 035-PS, is entitled, “A Brief Report
on Security Measures of the Chief Labor Group in the Ukraine
during the Withdrawal of the Armed Forces.” It was presented
to the Tribunal by our American colleagues on 18 December 1945.
A characteristic peculiarity of this document is that it openly
testifies to the looting. It is quite clear to all that reference is
made to a gang of robbers, although the Hitlerites still persist in
referring to robbery as work. They shipped the most valuable
exhibits of the Ukrainian Museum to Germany as “miscellaneous
textiles.”</p>
<p class="pindent">The report begins with the description of the creation of safe
quarters for the Einsatzstab establishments, a purpose for which
the inhabitants of an entire district were thrown out of their
quarters. There then follows, in this document, a list of booty
removed from the plundered museums of Kharkov and Kiev, from
archives, and even from private libraries.</p>
<p class="pindent">I shall quote one brief excerpt only from this document, dealing
with the contents of the Ukrainian and the prehistorical museum
of Kiev. You will find this excerpt on Page 368 of the document
book. I quote:</p>
<div class="blockquote">
<p class="calibre3">“October 1943, materials of the Ukrainian museum in Kiev.</p>
<p class="calibre3">“On the basis of the general evacuation orders of the city
commissioner, the following were sorted out by us and
loaded for shipment to Kraków:</p>
<p class="calibre3">“Miscellaneous textiles; collections of valuable embroidery
patterns; collections of brocades; numerous wooden utensils,
<span class="it1">et cetera</span>.
<span id="Page_89" title="89"></span></p>
<p class="calibre3">“Moreover, a large part of the prehistoric museum was carried
away.”</p>
</div>
<p class="pindent">The second, Document Number 1109-PS of 17 June 1944, is
headed, “Note for the Director of Operation Group P4,” and is
addressed to Von Milde-Schreden. I shall quote it completely
because it is really a short excerpt which you will find on Page 369
of the document book:</p>
<div class="blockquote">
<p class="calibre3">“2. The removal of cultural property.</p>
<p class="calibre3">“A great deal of material from museums, archives, institutions,
and other cultural establishments was in an orderly
manner removed from Kiev in the autumn of 1943.</p>
<p class="calibre3">“These actions to safeguard the material were carried out by
Einsatzstab RR, as well as by the individual directors of
institutes, <span class="it1">et cetera</span>, at the instigation of the Reich Commissioner.”</p>
</div>
<p class="pindent">Here, Your Honors, I would point out that Einsatzstab Rosenberg
in some documents is also referred to as the “Task Staff RR.”
These initials stand for Reichsleiter Rosenberg.</p>
<div class="blockquote">
<p class="calibre3">“At first, a great deal of the property that was to be evacuated
was taken only to the areas of the rear; later on, this
material was forwarded to the Reich. When the undersigned,
towards the end of September, received the order from the
cultural division of the Reich Commissioner to take out of
Kiev the remaining cultural effects, the materials most valuable
from a cultural point of view had already been removed.
During October some 40 carloads of cultural effects were
shipped to the Reich. In this case it was chiefly a question of
valuables which belonged to the research institutions of the
national research center of the Ukraine. These institutions,
at present, are continuing their work in the Reich and are
being directed in such a manner that at any given moment
they can be brought back to the Ukraine. The cultural values
which could not be promptly safeguarded incurred plunder.
In this case, however, it was always a question of less valuable
material, as the essential assets had been removed in an
orderly manner.</p>
<p class="calibre3">“In October 1943 factories, workshops, plants, and other
equipment were removed from Kiev by the order of the
town commander, but where it was taken, I do not know.”</p>
</div>
<p class="pindent">This letter ends with the following sentence:</p>
<div class="blockquote">
<p class="calibre3">“At the time the Soviets entered the city there was nothing
valuable, in this respect, left in the city.”</p>
</div>
<p class="pindent">May it please Your Honors, from the documents submitted by
the Soviet Prosecution, the Tribunal has already learned about the
<span id="Page_90" title="90"></span>
criminal conspiracy between Hitler and Antonescu. As a reward
for supplying Germany with cannon fodder, oil, wheat, cattle, <span class="it1">et
cetera</span>, Antonescu’s criminal clique received from Hitler’s Government
authorization to plunder the civilian population between the
Bug and the Dniester. German and Romanian invaders plundered
and destroyed many objects of cultural value, health resorts, and
medical institutions in Odessa. The Hitlerites also plundered on
their own account, as well as in co-operation with Antonescu’s
clique. To prove this, I shall now read into the record a few
excerpts from the report of the Extraordinary State Commission
of the Soviet Union, presented to the Tribunal as Exhibit Number
USSR-47 (Document Number USSR-47). These excerpts are taken
from Page 372 of your document book. I omit one paragraph and
begin to quote from the penultimate paragraph on this page of
my report:</p>
<div class="blockquote">
<p class="calibre3">“The German Military Command plundered the museums of
Odessa, carrying away hundreds of unique objects.”</p>
</div>
<p class="pindent">Further, I here omit two paragraphs and quote the last line of
Page 66:</p>
<div class="blockquote">
<p class="calibre3">“According to a plan, drawn up in advance, the German
fascist invaders . . . blew up or burned 2,290 of the largest
buildings of architectural, artistic, and historical value. Included
in these were the house of A. S. Pushkin . . . the Saban
barracks, built in 1827, and others, representing in themselves
valuable monuments to the material culture of the beginning
of the 19th century.</p>
<p class="calibre3">“In Odessa the German-Romanian invaders destroyed: The
first hospital for contagious diseases, the second district hospital,
the somatological hospital, the psychiatric hospital, and
two children’s hospitals, a children’s polyclinic, seven infant
consulting centers, 55 day nurseries, two maternity homes,
one dispensary, one leprosarium, six polyclinics, and research
institutions for the study of tuberculosis, for studying conditions
in spas and others. They destroyed 29 sanatoria located
around Odessa.”</p>
</div>
<p class="pindent">The Hitlerites committed crimes on an exceptionally large scale
in the Stalino Province. I omit the rest of this page and pass to
Page 68 of my report. The report of the Extraordinary State Commission,
presented by the Soviet Prosecution as Exhibit Number
USSR-2 (Document Number USSR-2), relates an enormous number
of facts. I shall not quote all of those, Your Honors; but I shall
confine myself only to several excerpts from the above-mentioned
document which have not yet been read into the record by my
colleagues. They can be found on Pages 374 and 375 in your document
book. I quote:
<span id="Page_91" title="91"></span></p>
<div class="blockquote">
<p class="calibre3">“During their retreat from Stalino, the Hitlerites completely
destroyed . . . 113 schools, 62 kindergartens, 390 shops, the
winter and summer theaters, the Palace of the Pioneers, the
radio theater, the Museum of the Revolution, the picture
gallery and the Dzerjinsky Club of the city.</p>
<p class="calibre3">“Special Engineer detachments went from school to school,
pouring incendiary liquid over them and setting them on fire.
Such Soviet people who tried to extinguish the fires were
immediately shot by the fascist scoundrels. . . .</p>
<p class="calibre3">“Exceptionally severe damages were caused by the invaders
to the medical establishments of the city.”</p>
</div>
<p class="pindent">I omit three paragraphs of the report, and I quote the penultimate
paragraph on this page:</p>
<div class="blockquote">
<p class="calibre3">“The Medical Institute, a model scientific establishment for
2,000 students, was destroyed on the orders of Oberfeldarzt
Roll, chief medical officer of Belindorf, and the chief medical
officer of Kuchendorf.</p>
<p class="calibre3">“Of a total of 600,000 books on science and art, 530,000
volumes were burned by the Hitlerites. . . .</p>
<p class="calibre3">“In the town of Makeyewka the German fascist invaders blew
up and burned down the city theater, seating 1,000 persons;
the circus, seating 1,500 persons; 49 schools, 20 day nurseries,
and 44 kindergarten schools. By order of the Town Commander,
Vogler, 35,000 volumes from the central Gorky
library were destroyed on a pyre.”</p>
</div>
<p class="pindent">I shall not enumerate all the cities. These facts were mentioned
in a document which, according to Article 21 of the Charter,
provides irrefutable evidence. In agreement with the rulings of
the Tribunal, this document will not be read into the record in
full. I must, however, draw your attention to the fact that in all
industrial towns of the Province of Stalino the Hitlerites burned
down schools, theaters, day nurseries, hospitals, and even churches.
Thus in the town of Gorlovka:</p>
<div class="blockquote">
<p class="calibre3">“. . . they destroyed 32 schools, attended by some 21,649 children,
burned down the town hospital, five polyclinics, a
church, and the Palace of Culture. . . .</p>
<p class="calibre3">“In the city of Konstantinovka the occupational authorities
blew up and burned down all the 25 city schools, two cinemas,
the central city library with 35,000 volumes, the Pioneers’
Club, the children’s technical center, the city hospital, and the
day nurseries.</p>
<p class="calibre3">“Before their retreat from Mariupol the German occupational
authorities burned down all the 68 schools of the city,
17 kindergarten schools . . . and the Palace of the Pioneers.”</p>
</div>
<p class="pindent"><span id="Page_92" title="92"></span></p>
<p class="pindent">I shall now quote a few excerpts from the document presented
to the Tribunal as Exhibit Number USSR 45 (Document Number
USSR-45). These excerpts are found on Page 378 of your document
book. The document deals with the Hitlerite crimes in Rovno and
the region of Rovno. The city of Rovno was of special importance.
It was the residence of Reich Minister Erich Koch, the closest collaborator
of the Defendant Rosenberg. Numerous conferences of the
Hitlerite leaders for elaborating their plan for the enslavement of
the Ukrainian people took place in this city. The above-mentioned
report of the Extraordinary State Commission established the following
facts:</p>
<div class="blockquote">
<p class="calibre3">“The Hitlerites, on the Ukrainian territory they had seized,
endeavored to establish a regime of slavery and serfdom and
to annihilate the Ukrainian sovereignty and culture. . . .</p>
<p class="calibre3">“The considerable material in possession of the Extraordinary
State Commission, based on documents, testimonies of witnesses,
and personal inspection by members of the commission,
and their acquaintance with conditions prevailing in
various cultural and educational establishments on Ukrainian
territory liberated by the Red Army, leaves no doubt that the
German fascist barbarians had for their aim the destruction
of Ukrainian culture and the extermination of the best representatives
of Ukrainian art and science who had fallen into
their hands.”</p>
</div>
<p class="pindent">I omit two paragraphs, and I quote the penultimate paragraph
on this page:</p>
<div class="blockquote">
<p class="calibre3">“The German fascist aggressors closed down nearly all the
cultural and educational establishments in Rovno. On 30 November
1941 the closing down of schools in the General Commissariat
of Volhynia and Podolia was officially announced
in the newspaper <span class="it1">Volyn</span>.”</p>
</div>
<p class="pindent">I omit the end of Page 70, and I quote the last paragraph of
this document on Page 71 of my report:</p>
<div class="blockquote">
<p class="calibre3">“The fact that all these crimes were committed in the residence
of the former Reich Commissioner for the Ukraine,
Erich Koch, serves as additional proof that all the crimes of
the Hitlerite bandits were perpetrated in execution of a plan
for the extermination of the Soviet people and the devastation
of the Soviet territories temporarily occupied by the Hitlerites,
a plan conceived and executed by the Hitlerite Government.”</p>
</div>
<p class="pindent">In Section 5 of his opening statement, General Rudenko, Chief
Prosecutor for the U.S.S.R., quoted an extract from a letter of the
<span id="Page_93" title="93"></span>
Commissioner General for Bielorussia, Kube, addressed to the
Defendant Rosenberg.</p>
<p class="pindent">This document is a typewritten letter, signed in ink by Kube.
It has several notations in pencil, evidently by the hand of Rosenberg;
and it has a stamp, “Ministerial Bureau,” and is dated
3 October 1941. This document, identified as Document Number
1099-PS, I submit to the Tribunal as Exhibit Number USSR-374 in
evidence of the enormous proportions assumed by the plundering
of historical treasures, carried out everywhere by the Hitlerites.</p>
<p class="pindent">With your permission I shall now take the liberty of quoting
some additional extracts from this document, which discloses the
fact that not only were the plundered treasures sent to Germany
but that they had also been stolen by individual generals of Hitler’s
Army. Kube’s letter reveals at the same time the existence of a
previously elaborated plan for the plunder of the cultural treasures
in Leningrad, Moscow, and the Ukraine. The vandalism of the
Hitlerites reached such proportions that even Kube, that hangman
of the Bielorussian people, was roused to indignation. He was afraid
of allowing a profitable deal to slip through his hands and sought
compensation from Rosenberg. I quote the second paragraph from
the beginning of the letter:</p>
<div class="blockquote">
<p class="calibre3">“Minsk possessed a large and, in part, a very valuable collection
of art treasures and paintings which have now been
removed almost in their entirety from the city. By order of
Reichsführer SS, Reichsleiter Heinrich Himmler, most of the
paintings, some still during my term of office, were packed
by the SS and sent to the Reich. They are worth several
millions which were withdrawn from the general district of
White Ruthenia. The paintings were supposedly sent to Linz
and to Königsberg in East Prussia. I beg to have this valuable
collection—as far as it is not needed in the Reich—placed
once more at the disposal of the general district of White
Ruthenia or, in any case, to place the monetary value of these
collections with the Ministry for the Occupied Eastern Territories.”</p>
</div>
<p class="pindent">Kube, as well as the Defendant Rosenberg, was of the opinion
that he had the right to monopolize the stolen treasures and complained—I
quote the second part of the second paragraph of this
letter:</p>
<div class="blockquote">
<p class="calibre3">“General Stubenrauch has taken a valuable part of this collection
and has carried it off to the area of military operations.
Sonderführer, whose names have not yet been reported to
me, have carried off three truckloads (without receipt) of
furniture, paintings, and objects of art.”</p>
</div>
<p class="pindent"><span id="Page_94" title="94"></span></p>
<p class="pindent">Having, along with other fascist leaders, robbed the people of
Bielorussia, and taken a direct part in the mass ill-treatment and
extermination of the Soviet population, Kube hypocritically declared—I
quote the last paragraph of this letter:</p>
<div class="blockquote">
<p class="calibre3">“Bielorussia, already poor in itself, has suffered heavy losses
through these actions.”</p>
</div>
<p class="line12">And Kube recommended to Rosenberg—I quote:</p>
<div class="blockquote">
<p class="calibre3">“I hope that experts will be appointed beforehand to prevent
such happenings in Leningrad and Moscow, as well as in
some of the ancient Ukrainian cultural centers.”</p>
</div>
<p class="line12">That was the ultimate goal of their ideas. It is now universally
known what meaning the Hitlerites attached to the word “measures”
when applied to the occupied territories. It meant a regime
of bloody terror and violence, of unrestricted plunder, and arbitrariness.</p>
<p class="pindent">On breaking into Minsk, capital of the Bielorussian Republic,
the German fascist invaders attempted to destroy the culture of
the Bielorussian people and to turn the Bielorussians into obedient
German slaves. As has been established by a special investigation,
the Hitlerite military authorities, acting on direct orders from the
German Government, ruthlessly destroyed scientific research institutes
and schools, theaters and clubs, hospitals and polyclinics,
kindergartens and day nurseries.</p>
<p class="pindent">I am reading into the record an excerpt from the document
which was presented by the Soviet Prosecution as Exhibit Number
USSR-38 (Document Number USSR-38).</p>
<div class="blockquote">
<p class="calibre3">“For 3 years the German fascist invaders in Minsk set out
to destroy, systematically, the scientific research institutes,
institutions of higher education, libraries, museums, institutions
of the academy of science, theaters, and clubs.</p>
<p class="calibre3">“The Lenin library in Minsk was a foundation more than
20 years old. In 1932 the work was completed by the construction
of a special new building with a large and well-equipped
depository for storing books. From this library the
Germans carried off to Berlin and Königsberg 1½ million
extremely valuable books on the history of Bielorussia. . . .”</p>
</div>
<p class="pindent">I omit the end of Page 73 of my report.</p>
<div class="blockquote">
<p class="calibre3">“In their attempt to eradicate the culture of the Bielorussian
people, the German fascist invaders destroyed every cultural
and educational institution in Minsk. . . . The libraries of the
Academy of Science, containing 30,000 volumes, of the State
University, of the Polytechnical Institute, and the medico-scientific
library and the public library of the city, A. S.
Pushkin, were carried away to Germany.
<span id="Page_95" title="95"></span></p>
<p class="calibre3">“The Hitlerites destroyed the Bielorussian State University
together with the Zoological, the Geological, and Mineralogical,
the Historical, and Archaeological Museums as well
as the Medical Institute with all its clinics. They also demolished
the Academy of Sciences with its nine institutes.”</p>
</div>
<p class="pindent">I omit the remainder of this paragraph.</p>
<div class="blockquote">
<p class="calibre3">“They destroyed the State Art Gallery and carried away to
Germany paintings and sculptures by Russian and Bielorussian
masters. . . . They plundered the Bielorussian State
Theater of Opera and Ballet, the First Bielorussian Dramatic
Theater, the House of National Creative Art, together with
the houses of the unions of writers, artists, and composers.</p>
<p class="calibre3">“In Minsk the fascists destroyed 47 schools, 24 kindergarten
schools, the Palace of the Pioneers, 2 lying-in hospitals, 3 children’s
hospitals, 5 municipal polyclinics, 27 nurseries, and
4 children’s welfare centers; the Institution of Infant and
Maternity Welfare was reduced to a heap of ruins.”</p>
</div>
<p class="pindent">The Prosecution has at its disposal Document Number 076-PS
which is a report entitled, “On Minsk Libraries,” by a German
private first class, Abel. This private had investigated all the
libraries in Minsk and stated in his report that nearly all of them
had been destroyed.</p>
<p class="pindent">I present this report as Exhibit Number USSR-375 (Document
Number USSR-375). I consider, Mr. President, that it will be quite
sufficient to read into the record individual excerpts from this
report. There is no need to read the report in its entirety. It is
stated, on Page 75 of my report, that:</p>
<div class="blockquote">
<p class="calibre3">“The Lenin library was the central library of Bielorussia. It
is difficult to estimate the number of volumes, but the
number of books is approximately 5 millions. . . . The depositories
for storing books present a desolate picture. . . .”</p>
</div>
<p class="pindent">I omit two paragraphs of my report, and I quote further:</p>
<div class="blockquote">
<p class="calibre3">“The library of the Polytechnical Institute in the basement
of the left wing, as well as a great number of laboratories,
were devastated beyond hope and left in complete disorder.”</p>
</div>
<p class="pindent">The report concludes with the following sentence, which I quote:</p>
<div class="blockquote">
<p class="calibre3">“The purpose of this report”—wrote the German private—“can
be achieved only if submitted to the Supreme Command
and when the command will issue the necessary orders plainly
forbidding the German soldier from behaving like a barbarian.”</p>
</div>
<p class="pindent">But such orders never followed and never could follow, since
fascism and barbarism are inseparable; fascism, in fact, means
barbarism.
<span id="Page_96" title="96"></span></p>
<p class="pindent">THE PRESIDENT: What were you proposing to do after the
adjournment this afternoon?</p>
<p class="pindent">MR. COUNSELLOR RAGINSKY: After the recess I shall present
several written documents pertaining to the destruction of cultural
valuables in the Lithuanian, Estonian, and Latvian Republics and
later, with the permission of the Tribunal, I should like to present
a documentary film, so that at the close of the session all presentation
of evidence would be completed and my report finished.</p>
<p class="pindent">THE PRESIDENT: How long will the film take?</p>
<p class="pindent">MR. COUNSELLOR RAGINSKY: The presentation of the documentary
film will take about 30 to 35 minutes.</p>
<p class="pindent">THE PRESIDENT: Do you not think that after the vast amount
of damage and spoliation to which you have drawn our attention
in some detail it would be sufficient if you were to summarize by
telling us the countries in which similar spoliation had taken place?
It is difficult to assimilate all this vast amount of detail.</p>
<p class="pindent">MR. COUNSELLOR RAGINSKY: I have in mind, Mr. President,
to present to the Tribunal a document which will serve as a summary
and in which all the general totals will be given.</p>
<p class="pindent">THE PRESIDENT: Very well. We will adjourn now for 10
minutes.</p>
<p class="line13">[<span class="it1">A recess was taken.</span>]</p>
<p class="pindent">MR. COUNSELLOR RAGINSKY: I wish to draw the attention of
the Tribunal for a few minutes to the fact that before presenting
the conclusion of this document I should like to read into the
record a German document referring to the subject.</p>
<p class="pindent">Having occupied the Lithuanian, Estonian, and Latvian Soviet
Republics, the German fascist invaders attempted to reduce the
Soviet Baltic provinces to the status of a German colony and to
enslave the people of these republics. This criminal design of the
Hitlerite Government found its full expression in universal plunder,
general ruin, violence, degradation, and in the mass murder of old
men, women, and children.</p>
<p class="pindent">In order to germanize the people of the Lithuanian, Estonian,
and Latvian Soviet Socialist Republics, the Hitlerites destroyed, by
all possible means, the culture of the peoples of these republics. I
skip the remainder of Pages 76, 77, and 78, and from Page 79
I quote one paragraph only:</p>
<div class="blockquote">
<p class="calibre3">“The capital of Soviet Latvia, Riga, was declared by the occupational
authorities as the capital of ‘Ostland’ (Eastern
Territory) and the seat of Staff Rosenberg.”</p>
</div>
<p class="pindent"><span id="Page_97" title="97"></span></p>
<p class="pindent">In the documents presented to the Tribunal by the Soviet Prosecution
as Document Number USSR-7, Document Number USSR-39,
and Document Number USSR-41, there are a number of facts
which do not and cannot exhaust the crimes perpetrated by the
German fascist invaders in the Soviet Baltic provinces. Among the
monstrous crimes against the peoples of the Baltic provinces, the
Defendant Rosenberg, the former Reich Minister, played a major part.</p>
<p class="pindent">I read from Page 81. Even at the time when it was quite evident
that the downfall of fascist Germany was fast approaching, when
the hour of just and stern retribution was facing the Hitler
criminals, the Defendant Rosenberg still continued in his plundering.
As late as the end of August 1944, Rosenberg organized and
executed the plundering of cultural resources in Riga and Reval,
in Dorpat, and in a number of towns in the Estonian Republic.</p>
<p class="pindent">I draw the attention of the Tribunal to Document Number
161-PS, dated 23 August 1944, entitled “Assignment” and signed by
Rosenberg’s Chief of Staff, Utikal. This document is submitted to
the Tribunal as Exhibit Number USSR-376 (Document Number
USSR-376), which Your Honors will find on Page 400 of the document
book. I quote:</p>
<div class="blockquote">
<p class="calibre3">“Order. On 21 August 1944, Reichsleiter Alfred Rosenberg
requested Haupteinsatzführer Friedrich Schueller from the
Einsatzstab RR to report on the possibilities still existing for
the evacuation of cultural treasures from the eastern territories.
On the basis of this report the Reichsleiter has ruled
that the most precious cultural riches of the Ostland could
still be removed by his staff, insofar as this can be done
without interfering with the interests of the fighting forces.
The Reichsleiter specified the following cultural objects as
having particular value:</p>
<p class="calibre3">“From Riga—the city archives, the state archives (the major
part of these were in Edwahlen);</p>
<p class="calibre3">“From Reval—the city archives, the Estonian Literary Society,
and small collections from Schwarzhäupterhaus, the town
hall, Evangelical Lutheran consistory, and Nicolas’ Church.</p>
<p class="calibre3">“From Dorpat—the university library; collections evacuated to
Estonian estates—Jerlep, Wodja, Weissenstein, and Lachmes.</p>
<p class="calibre3">“Haupteinsatzführer Schueller, in his capacity as acting
director of the main working group of the Einsatzstab RR,
is commissioned with the carrying out of the removal and
shipment.</p>
<p class="calibre3">“He is advised to maintain special contact with Army Group
North in order to co-ordinate the execution of this mission
<span id="Page_98" title="98"></span>
of the Reichsleiter, with the transportation requirements of
the field forces.</p>
<p class="calibre3">“Utikal, chief of Einsatzstab”</p>
</div>
<p class="pindent">I should like to draw the attention of the Tribunal to another
peculiar circumstance. In this case, too, the looting was carried out
by Rosenberg together with the High Command, and as late as the
fall of 1944, “future chiefs” of Staff Rosenberg were selected.</p>
<p class="pindent">An analysis of all these circumstances permits us categorically
to reassert that the destruction and looting of cultural valuables
was inspired, directed, and executed by a central organization, and
that this central organization was the criminal Hitler Government
and the High Command, the representatives of which, in the persons
of all the defendants in this Trial, should suffer punishment in
accordance with Article 6 of the Charter of the International
Military Tribunal.</p>
<p class="pindent">May it please Your Honors, when we deal with a system of
wholesale destruction and plunder, it is impossible, and scarcely
necessary, to enumerate all the facts, even if these facts are, <span class="it1">per
se</span>, of great importance. In the occupied territories of the Soviet
Union the Hitlerites carried out precisely such a system of wholesale
and manifold destruction and plunder of cultural treasures of the
peoples of the U.S.S.R. At this moment it is not yet possible to
draw up an exhaustive balance of the defendants’ crimes.</p>
<p class="pindent">But I shall, with the permission of the Tribunal, submit a document
containing data which, although only of a preliminary nature,
are absolutely accurate and bear witness to the tremendous damage
inflicted by the Hitlerites.</p>
<p class="pindent">I have in view the report of the Extraordinary State Commission
of the Soviet Union, submitted to the Tribunal as Exhibit
Number USSR-35 (Document Number USSR-35). This document
is on Pages 404 and 405 of your document book. From this I shall
only quote individual excerpts concerning the subject which I am
presenting and which have not yet been read into the record:</p>
<div class="blockquote">
<p class="calibre3">“Destruction of Cultural-Social Institutions, Public Organizations,
and Co-operatives.</p>
<p class="calibre3">“The German plunderers destroyed various establishments,
clubs, stadia, rest homes, and sanatoria belonging to consumer
and industrial co-operatives, trade unions, and other
public organizations . . . in the occupied territory of the
U.S.S.R. They destroyed over 87,000 industrial buildings
belonging to co-operatives, trade unions, and other social
organizations; 10,000 residential buildings and 1,839 cultural
and social institutions. They carried off to Germany about
8,000,000 books. . . .
<span id="Page_99" title="99"></span></p>
<p class="calibre3">“Of the property of the trade unions the German invaders
completely destroyed 120 sanatoria and 150 rest homes in
which over 3 million workers, engineers, technicians, and other
employees spent their annual rest leave. Of this total figure
they destroyed, in the Crimea 59 sanatoria and rest homes. . .
in the spas of the Caucasus 32 sanatoria and rest homes; in
the Leningrad area 33 sanatoria and rest homes; in the
Ukraine 88 sanatoria and rest homes.</p>
<p class="calibre3">“The German fascist invaders destroyed the buildings of
46 pioneer camps and children’s convalescent institutions
belonging to the trade unions. They destroyed 189 clubs and
palaces of culture.”</p>
</div>
<p class="pindent">I omit one paragraph and quote the last paragraph on this page:</p>
<div class="blockquote">
<p class="calibre3">“In the territory of the Soviet Union which was occupied
by the Germans, at the beginning of 1941, there were 82,000
elementary and secondary schools with 15 million pupils. All
the secondary schools possessed libraries, each with from
2,000 to 25,000 volumes; many schools possessed auditoria for
physics, chemistry, biology, and others. . . .</p>
<p class="calibre3">“The German fascist invaders burned, destroyed, and plundered
these schools with their entire property and equipment. . . .”</p>
</div>
<p class="pindent">I omit the end of this paragraph.</p>
<div class="blockquote">
<p class="calibre3">“The German fascist invaders entirely or partially destroyed
334 colleges at which 233,000 students were studying; they
removed to Germany the equipment of the laboratories and
lecture rooms together with the exhibits, unique of their
kind, from the collections of the universities, institutes, and
libraries.</p>
<p class="calibre3">“Great damage was inflicted on the medical colleges. . . .</p>
<p class="calibre3">“The occupants destroyed or looted 137 pedagogical institutions
and teachers’ colleges. . . . They removed historical material
and ancient manuscripts from special libraries, and stole or
destroyed over 100 million volumes in the public libraries.”</p>
</div>
<p class="pindent">I omit the next paragraph:</p>
<div class="blockquote">
<p class="calibre3">“They destroyed, on the whole, 605 scientific research institutes.”</p>
</div>
<p class="pindent">I omit the end of Page 85 of my report and the first paragraph
of Page 86.</p>
<div class="blockquote">
<p class="calibre3">“Enormous damage was inflicted by the Germans on the
medical establishments of the Soviet Union. They destroyed
or plundered 6,000 hospitals, 33,000 polyclinics, dispensaries,
and out-patient departments, 976 sanatoria and 656 rest
homes.”</p>
</div>
<p class="pindent"><span id="Page_100" title="100"></span></p>
<p class="pindent">I omit the next three paragraphs.</p>
<div class="blockquote">
<p class="calibre3">“Destruction of Museums and Historical Monuments.</p>
<p class="calibre3">“In the occupied territories the German fascist invaders destroyed
427 out of a total of 992 museums of the Soviet
Union.”</p>
</div>
<p class="pindent">I omit the end of this page and quote the beginning of Page 87
of the report:</p>
<div class="blockquote">
<p class="calibre3">“The Germans also destroyed the museum of the peasant poet
S. D. Drozhzhin, in the village of Zavidovo, the museum of
the people’s poet I. S. Nikitin, in Voronezh, and the museum
of the famous Polish poet Adam Mickiewicz, at Novogrudka
in the Bielorussian S.S.R. At Alagir they burned the manuscript
of the national singer Osetij Kosta Khetagurov.</p>
<p class="calibre3">“The German fascist invaders destroyed 44,000 theaters, clubs,
and so-called ‘Red corners.’ ”</p>
</div>
<p class="pindent">Now with the permission of the Tribunal, I should like to submit
a documentary film and a certificate testifying to the documentary
character of this film. The film is entitled, “Destruction of
Art and Museums of National Culture perpetrated by the Germans
on the Territory of the U.S.S.R.” This film and the documents
testifying to the documentary nature of these reels are submitted
to the Tribunal as Exhibit Number USSR-98 (Document Number
USSR-98). In this film, besides documentary photographs taken between
1941-45, there are also extracts made in 1908, showing Yasnaya
Polyana and Leo Tolstoy. Subsequent photographs show what
the German invaders did to this cultural relic of the Soviet people.</p>
<p class="pindent">May I proceed with the presentation of the film, Your Honor?</p>
<p class="pindent">THE PRESIDENT: Yes, of course.</p>
<p class="pindent">[<span class="it1">Moving pictures were then shown.</span>]</p>
<p class="pindent">MR. COUNSELLOR RAGINSKY: I must dwell, Your Honors,
on one more category of crimes committed by the Hitlerites—the
spoliation and destruction of churches, convents, and other places
of religious worship.</p>
<p class="pindent">By destroying monasteries, churches, mosques, and synagogues
and robbing their property, the German invaders sadistically mocked
the religious feelings of the people. These blasphemous crimes
assumed a general appearance in all the territories which were
under German rule. Soldiers and officers organized bloody orgies
in places of worship, kept horses and dogs in the churches, donned
the church vestments, and made sleeping bunks out of the icons.</p>
<p class="pindent">I shall not trespass on your time by reading all the numerous
documents at the disposal of the Soviet Prosecution, and shall
merely dwell on some of these, in particular on the documentary
<span id="Page_101" title="101"></span>
photographs, an album of which I present to the Tribunal as Exhibit
Number USSR-99 (Document Number USSR-99).</p>
<p class="pindent">With your permission, I should like to read a few more documents
and particularly a short extract from the document which
has already been presented to the Tribunal as Exhibit Number
USSR-51(3) (Document Number USSR-51(3)). You can find this
extract in your document book on the back of Page 321. I quote:</p>
<div class="blockquote">
<p class="calibre3">“The Hitlerite invaders do not spare the religious sentiments
of the believing section of the Soviet population either. They
have burned, looted, blown up, and desecrated hundreds of
churches on Soviet territory, including several irreplaceable
monuments of ancient church architecture.”</p>
</div>
<p class="pindent">I omit two paragraphs, and I quote the next one:</p>
<div class="blockquote">
<p class="calibre3">“The priest Amvrosy Ivanov writes from the village of
Iklinskoye, in the Moscow region:</p>
<p class="calibre3">“ ‘Before the arrival of the Germans the church was in complete
order. A German officer ordered me to take everything
out of the church. . . . At night troops arrived, occupied the
church, brought in their horses. . . . Then they began to smash
and break everything in the church and to build bunks. They
threw out everything: the altar, the holy gates and banners,
and the holy shroud. In a word, the church was turned into
a robbers’ den.’ ”</p>
</div>
<p class="pindent">I omit the remaining part of Page 88, and I read Page 89 of
the report:</p>
<div class="blockquote">
<p class="calibre3">“In the village of Gosteshevo, the Germans plundered the
church, broke up the holy banners, threw the books about,
robbed the Reverend Mikhail Strakhov and carried him off
with them to another district. In the village of Kholm, near
Mozhaisk, the Germans robbed and beat up the 82-year-old
local priest. In retreating from Mozhaisk, the Germans blew
up the Church of the Ascension, the Church of the Holy
Trinity, and the Cathedral of Nicholas, the miracle worker.
As a rule, before retreating, the Germans would drive part
of the population of the villages destroyed by fire into the
churches, lock them up, and then set fire to these churches.”</p>
</div>
<p class="pindent">I am now reading into the record a short excerpt from Exhibit
Number USSR-312 (Document Number USSR-312), submitted to the
Tribunal:</p>
<div class="blockquote">
<p class="calibre3">“In a north side-altar of the Znamensky Cathedral, the Germans
set up a latrine for the soldiers living in the crypt of
the cathedral.</p>
<p class="calibre3">“The Church of the Prophet Elijah on the Slavna was transformed
into a stable.
<span id="Page_102" title="102"></span></p>
<p class="calibre3">“Stables were built in the following Pskov churches: Bogoyavlenie
on Zapskovie, Kozma and Demian on the Gremiatchy
Hill, Constantine and Helen, and in the Church of Saint John
the Evangelist.”</p>
</div>
<p class="pindent">The document which was presented to the Tribunal as Exhibit
Number USSR-279 (Document Number USSR-279) describes facts of
blasphemous mockery which took place in the town of Gjatsk where
the churches were transformed by the Germans into stables and warehouses.
In the Church of the Annunciation the Germans set up a
slaughterhouse for horned cattle.</p>
<p class="pindent">The document which I am now presenting to the Tribunal as
Exhibit Number USSR-246 (Document Number USSR-246) is a
report of the Extraordinary State Commission of the Soviet Union
and contains general data relating to the churches, chapels, and
other institutions of religious worship which have been destroyed
or damaged. This document states:</p>
<div class="blockquote">
<p class="calibre3">“The German fascist invaders completely destroyed or partly
damaged 1,670 churches, 69 chapels, 237 Roman Catholic
churches, four mosques, 532 synagogues, and 254 other buildings
for religious worship.”</p>
</div>
<p class="pindent">Your Honors will find in the document, submitted to the
Tribunal as Exhibit Number USSR-35 (Document Number USSR-35),
these general data on the subject. I will not burden the Tribunal’s
attention by reading the document into the record in full, but I
should like to quote a few very short excerpts from it. I quote:</p>
<div class="blockquote">
<p class="calibre3">“The material responsibility by the Germans cannot make
complete amends for the destruction of ecclesiastical buildings,
and of the most ancient historical monuments; the majority
of these can never be restored.”</p>
</div>
<p class="pindent">Omitting the remainder of the page, as well as the first four
paragraphs of Page 91 of the report, I read the last paragraph
of this page:</p>
<div class="blockquote">
<p class="calibre3">“Many churches, historical monuments of antiquity, were
destroyed by the German invaders in Bielorussia. Thus, in
the city of Vitebsk, they destroyed the Church of the Nativity,
an interesting monument of Bielorussian architecture of the
12th century. They completely destroyed the wooden Apostle
and Saint Nicholas Churches, built in the 18th century.</p>
<p class="calibre3">“Almost irreparable damage was done to the Voskresenko-Zaruchjevsky
Church, built in the 18th century. This church
was an interesting example of the Bielorussian classic style
of architecture. In the same area, in the city of Vitebsk, the
Germans destroyed a Roman Catholic church built in the 18th
century. . . .
<span id="Page_103" title="103"></span></p>
<p class="calibre3">“In the town of Dyesna, of the Polotsk region, the Germans
burned a Roman Catholic church founded in the 17th century,
after plundering its property.</p>
<p class="calibre3">“Timoschel Rudolf, German garrison commandant of the town
of Rozhnyatov, in the Stanislav region, used three synagogues
for barracks and later on destroyed the buildings after plundering
the property contained therein.”</p>
</div>
<p class="pindent">I omit the next paragraph.</p>
<div class="blockquote">
<p class="calibre3">“Before destroying buildings of various religious cults the
Germans plundered and destroyed all their equipment. A
great number of icons and church decorations were removed
from ecclesiastical buildings to Germany.</p>
<p class="calibre3">“The Joseph-Volokalamsky Monastery was plundered and
the ancient shrouds of the monastery, together with the
personal belongings of Joseph Volotsky, founder of the monastery,
have disappeared. . . .</p>
<p class="calibre3">“In 1941 German soldiers and officers stole from the Staritzki
Church all the vessels, altar crosses, crowns, miters, and
tabernacles.</p>
<p class="calibre3">“In the town Dokshitza, in the Polotsk region, the Germans
looted and took away all the property of the local mosque.
The same fate was shared by nearly all the churches in the
territories occupied by the Germans.</p>
<p class="calibre3">“Everywhere the Germans plundered Orthodox and Catholic
churches, synagogues, mosques, and other buildings of
religious worship.”</p>
</div>
<p class="pindent">The Hitlerite conspirators not only actually plundered, tortured,
and murdered, but they also strove to humiliate the believers
morally and to rob them of their spiritual treasures.</p>
<p class="pindent">Such, Your Honors, is the conclusive evidence concerning the
crimes against culture, committed by Rosenberg, Frank, Göring,
Ribbentrop, Keitel, and the other participants in the conspiracy.
The crimes of the defendants against culture are terrible indeed
in their consequences. Even though it be possible, by a tremendous
effort, to rebuild the cities and villages destroyed by the Hitlerites,
even though it be possible to restore the factories and plants blown
up or burned down by them, mankind has lost for all time the irreplaceable
art treasures which the Hitlerites so ruthlessly destroyed,
as it has lost forever the millions of human beings sent to their
death in Auschwitz, Treblinka, Babye-yar, or Kerch.</p>
<p class="pindent">Having inherited the savage hatred of all mankind from the
dim ages of the past, the modern Huns have far surpassed, in
cruelty and vandalism, the darkest pages of history. While arrogantly
challenging the future of mankind, they trampled under
<span id="Page_104" title="104"></span>
foot the finest heritage of mankind’s past. Themselves without faith
or ideals, they sacrilegiously destroyed both the churches and the
relics of the saints.</p>
<p class="pindent">But in this unparalleled struggle between culture and obscurantism,
between civilization and barbarism, culture and civilization
prevailed. The Hitlerite conspirators who had aspired to world
domination, who had dreamed of destroying the culture of the Slavs
and of all other nations, now stand in the defendants’ dock. May a
just punishment be theirs.</p>
<p class="pindent">THE PRESIDENT: Will you continue until 5 o’clock?</p>
<p class="pindent">MR. COUNSELLOR RAGINSKY: As you wish, Your Honor.</p>
<p class="pindent">THE PRESIDENT: Yes; will you go on until 5 o’clock?</p>
<p class="pindent">MR. COUNSELLOR RAGINSKY: I should only like to ask for
a few minutes’ interval in order to collect some documents. It will
literally take only a few moments.</p>
<p class="pindent">THE PRESIDENT: It would be hardly worth while if you want
a short interval. We shall stop at 5 o’clock.</p>
<p class="pindent">MR. COUNSELLOR RAGINSKY: It would perhaps be more
convenient to begin again at 1000 hours tomorrow.</p>
<p class="pindent">THE PRESIDENT: Then we will adjourn now.</p>
<p class="line14">[<span class="it1">The Tribunal adjourned until 22 February 1946 at 1000 hours.</span>]</p>
<div class="calibre2"><span id="Page_105" title="105"></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?3770979a